<template>
  <div class="ifttt-form ">
    <div class="row header">
      <div class="col-12 ifttt-progress">
        <step-progress :active-thickness="2" :passive-thickness="2" :line-thickness="2" :active-color="'#2A52BE'"
                       :pasive-color="'#CED4DA'"
                       :steps="allSteps" :current-step="currentStep" icon-class="fa fa-check"></step-progress>
      </div>
    </div>
    <div class="row content">
      <!-- Step one: name -->
      <template v-if="currentStep === 0 ">
        <div class="col-12">
          <label for="name-properties">{{ $t('ifttt.name') }}</label>
          <input type="text" id="name-properties" class="form-control" v-model="ifttt.name">
        </div>
      </template>
      <!-- Step two: triggers -->
      <template v-if="currentStep === 1">
        <div class="col-12 trigger-info">

        </div>

        <div class="col-12">
          <label for="trigger-properties">{{ $t('ifttt.trigger') }}</label>
          <select @change="removeFilters" name="" class=form-control v-model="ifttt.trigger.type"
                  id="trigger-properties">
            <option disabled selected :value="null">
              {{ $t('ifttt.chooseATrigger') }}
            </option>
            <option v-for="trigger of possibleTriggers" :key="trigger.type" :value="trigger.type">
              {{ $t('ifttt.triggerOptions.' + trigger.type) }}
            </option>
          </select>
        </div>
        <div class="col-12 my-4" v-if="shouldShowTimeInput">
          <label for="trigger-time-value">{{ $t('ifttt.time') }}</label>
          <input
              id="trigger-time-value"
              type="time"
              class="form-control"
              v-model="ifttt.trigger.value"
          />
        </div>
        <div class="col-12 my-4" v-if="getTriggerFilters.length">
          <div class="row extra-filters">
            <div class="col d-flex justify-content-center text-center" :key="filter.key"
                 v-for="filter of possibleTriggerFilters">
              <template v-if="filter.type === 'DATE'">
                <div @click="toggleDayFilter(filter)" :active="triggerFilterIsActive(filter)" class="day-circle">
                  {{ filter.value }}
                </div>
              </template>
            </div>
          </div>
        </div>

      </template>
      <!-- Step 3: Filters --->
      <template v-if="currentStep === 2 ">
        <div class="col-12">
          <label for="name-properties">{{ $t('ifttt.filters') }}</label>
          <VoerroTagsInput id="filters"
                           :existing-tags="getPossibleFilters"
                           :value-fields="'length'"
                           :typeahead-activation-threshold="threshold"
                           :typeahead-always-show="false"
                           @focus="threshold = 0"
                           :typeahead-max-results="100"
                           @blur="threshold = 1;"
                           @tags-updated="changedTags"
                           :typeahead-hide-discard="true"
                           :typeahead-style="'dropdown'"
                           v-model="ifttt.filters"
                           :limit="0"
                           :sort-search-results="false"
                           :placeholder="$t('ifttt.filtersPlaceholder')"
                           :add-tags-on-blur="false"
                           :hide-input-on-limit="true"
                           :typeahead="true"></VoerroTagsInput>
        </div>
        <span class="extra-info-text" v-if="ifttt.filters.length">{{ $t('ifttt.formulaFirstPart') }} <b>{{
            getFormula
          }}</b></span><br/>
      </template>
      <!-- Step 4: Action -->
      <template v-if="currentStep === 3">
        <div class="col-12">
          <label for="action-property">{{ $t('ifttt.action') }}</label>
          <select @change="setType" name="" class=form-control v-model="ifttt.action.type" id="action-property">
            <option disabled selected :value="null">
              {{ $t('ifttt.chooseAction') }}
            </option>
            <option v-for="action of actions" :key="action.value" :value="action.value">
              {{ $t('ifttt.actionOptions.' + action.value) }}
            </option>
          </select>
        </div>
        <template v-if="(ifttt.action.type === 'DECLARE_ACTIVE_DOWNTIME_AS_SPECIFIC_REASON' ||
          ifttt.action.type === 'DECLARE_UNDECLARED_DOWNTIME_AS_SPECIFIC_REASON' ||
          ifttt.action.type === 'DECLARE_ACTIVE_UNDECLARED_DOWNTIME_AS_SPECIFIC_REASON')">
          <div class="col-12" :key="'select-reason-tree-for-workflow-'+ workflow.key"
               v-for="workflow of getReasonTreesToSelect">
            <label>{{ $t('ifttt.chooseReasonForWorkflow', {name: workflow.value}) }}</label>
            <ReasonOnlyTreePicker @levelChanged="levelChanged($event, workflow.key)"
                                  :downTime="getFakeDownTimeOfWorkflowId(workflow.key)"
                                  :down-time-id="workflow.key"/>
          </div>
        </template>
      </template>
    </div>

    <div class="row footer">
      <div class="col-auto" v-if="currentStep > 0">
        <button @click="currentStep--" class="progress-button">
          <i class="fas fa-chevron-left"></i>
          <span>{{ $t('ifttt.previous') }}</span>
        </button>
      </div>
      <div class="col">
      </div>
      <div class="col-auto">
        <button v-if="currentStep !== allSteps.length-1" :disabled="!canGoNext" @click="currentStep++"
                class="progress-button">
          <span>{{ $t('ifttt.next') }}</span>
          <i class="fas fa-chevron-right"></i>
        </button>
        <Button v-if="currentStep === allSteps.length-1"
                :disabled="!validifttt"
                @frameworkButtonClicked="save()"
                :backgroundColor=$motivateColors.ceruleanBlue
                :outline=$motivateColors.ceruleanBlue
                :color=$motivateColors.walterWhite
                :size="'unset'">
          <template #button-content>
            <div class="save-button">
              <div>{{ $t('ifttt.save') }}</div>
              <span class="far fa-save"></span>
            </div>
          </template>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/general/Button.vue";
import VoerroTagsInput from '@voerro/vue-tagsinput';
import {mapGetters} from "vuex";
import ReasonOnlyTreePicker from "@/components/reasonTrees/ReasonOnlyTreePicker";

export default {
  name: "iftttForm",
  props: ['originalIfttt'],
  components: {
    Button,
    VoerroTagsInput,
    ReasonOnlyTreePicker
  },
  data() {
    return {
      allSteps: [this.$t('ifttt.general'), this.$t('ifttt.triggers'), this.$t('ifttt.filters'), this.$t('ifttt.actions')],
      threshold: 1,
      currentStep: 0,
      possibleTriggers: [
        {
          type: 'SPECIFIC_TIME_REACHED',
          valueType: 'time'
        }, {
          type: 'SHIFT_CHANGED',
          valueType: 'shift'
        }, {
          type: 'SETUP_TARGET_EXPIRED',
          valueType: 'timespan'
        }],
      possibleTriggerFilters: [
        {
          key: 'DAY_0',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: _.capitalize(moment().startOf("isoWeek").locale(this.$root.$i18n.locale).format('dd')),
          type: 'DATE'
        },
        {
          key: 'DAY_1',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: _.capitalize(moment().startOf("isoWeek").add(1, 'day').locale(this.$root.$i18n.locale).format('dd')),
          type: 'DATE'
        },
        {
          key: 'DAY_2',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: _.capitalize(moment().startOf("isoWeek").add(2, 'day').locale(this.$root.$i18n.locale).format('dd')),
          type: 'DATE'
        },
        {
          key: 'DAY_3',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: _.capitalize(moment().startOf("isoWeek").add(3, 'day').locale(this.$root.$i18n.locale).format('dd')),
          type: 'DATE'
        },
        {
          key: 'DAY_4',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: _.capitalize(moment().startOf("isoWeek").add(4, 'day').locale(this.$root.$i18n.locale).format('dd')),
          type: 'DATE'
        },
        {
          key: 'DAY_5',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: _.capitalize(moment().startOf("isoWeek").add(5, 'day').locale(this.$root.$i18n.locale).format('dd')),
          type: 'DATE'
        },
        {
          key: 'DAY_6',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: _.capitalize(moment().startOf("isoWeek").add(6, 'day').locale(this.$root.$i18n.locale).format('dd')),
          type: 'DATE'
        },
      ],
      possibleFilters: [
        {
          key: 'DAY_0',
          showOnTriggerValueTypes: [],
          value: _.capitalize(moment().startOf("isoWeek").locale(this.$root.$i18n.locale).format('dddd')),
          type: 'DATE'
        },
        {
          key: 'DAY_1',
          showOnTriggerValueTypes: [],
          value: _.capitalize(moment().startOf("isoWeek").add(1, 'day').locale(this.$root.$i18n.locale).format('dddd')),
          type: 'DATE'
        },
        {
          key: 'DAY_2',
          showOnTriggerValueTypes: [],
          value: _.capitalize(moment().startOf("isoWeek").add(2, 'day').locale(this.$root.$i18n.locale).format('dddd')),
          type: 'DATE'
        },
        {
          key: 'DAY_3',
          showOnTriggerValueTypes: [],
          value: _.capitalize(moment().startOf("isoWeek").add(3, 'day').locale(this.$root.$i18n.locale).format('dddd')),
          type: 'DATE'
        },
        {
          key: 'DAY_4',
          showOnTriggerValueTypes: [],
          value: _.capitalize(moment().startOf("isoWeek").add(4, 'day').locale(this.$root.$i18n.locale).format('dddd')),
          type: 'DATE'
        },
        {
          key: 'DAY_5',
          showOnTriggerValueTypes: [],
          value: _.capitalize(moment().startOf("isoWeek").add(5, 'day').locale(this.$root.$i18n.locale).format('dddd')),
          type: 'DATE'
        },
        {
          key: 'DAY_6',
          showOnTriggerValueTypes: [],
          value: _.capitalize(moment().startOf("isoWeek").add(6, 'day').locale(this.$root.$i18n.locale).format('dddd')),
          type: 'DATE'
        },
        {
          key: 'DOWNTIME_ACTIVE',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: this.$t('ifttt.filterOptions.DOWNTIME_ACTIVE'),
          type: 'DOWNTIME_STATUS'
        },
        {
          key: 'DOWNTIME_NOT_ACTIVE',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: this.$t('ifttt.filterOptions.DOWNTIME_NOT_ACTIVE'),
          type: 'DOWNTIME_STATUS'
        },
        {
          key: 'DOWNTIME_DECLARED',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: this.$t('ifttt.filterOptions.DOWNTIME_DECLARED'),
          type: 'DOWNTIME_DECLARATION_STATUS'
        },
        {
          key: 'DOWNTIME_UNDECLARED',
          showOnTriggerValueTypes: ['time', 'shift'],
          value: this.$t('ifttt.filterOptions.DOWNTIME_UNDECLARED'),
          type: 'DOWNTIME_DECLARATION_STATUS'
        }
      ],
      actions: [
        {type: 'downtime', value: 'DECLARE_ACTIVE_UNDECLARED_DOWNTIME_AS_SPECIFIC_REASON'},
        {type: 'downtime', value: 'CUT_DOWNTIME'}
      ],
      ifttt: {
        id: null,
        name: '',
        trigger: {type: null, value: null},
        triggerFilters: [],
        filters: [],
        action: {type: null, value: null},
        type: null
      }
    }
  },
  computed: {
    ...mapGetters('workflows', ['getWorkflows']),
    ...mapGetters('reasonTrees', ['getReasonTrees']),
    ...mapGetters('users', ['getClaims']),
    ...mapGetters('company', ['getActivities']),
    validifttt() {
      // Full validation check of ifttt.
      console.log("VALID?", this.ifttt)
      if (!this.ifttt.name.length) {
        return false;
      } else if (this.ifttt.trigger.type === null || this.ifttt.trigger.valueType === null) {
        return false;
      } else if (this.ifttt.action.type === null) {
        return false;
      } else if (this.ifttt.action.type === 'DECLARE_ACTIVE_DOWNTIME_AS_SPECIFIC_REASON' ||
          this.ifttt.action.type === 'DECLARE_UNDECLARED_DOWNTIME_AS_SPECIFIC_REASON' ||
          this.ifttt.action.type === 'DECLARE_ACTIVE_UNDECLARED_DOWNTIME_AS_SPECIFIC_REASON') {
        // Check if every workflow has a reason

        // Get all workflows that are filtered OR all workflows if there is no filter
        let workflowsToFill = _.filter(this.ifttt.filters, {'type': 'WORKFLOW'});
        if (!workflowsToFill.length) {
          workflowsToFill = _.map(this.getWorkflows, workflow => {
            return {key: workflow.id, value: workflow.name, type: 'WORKFLOW'}
          });
        }
        // Now filter the workflows without a declartion reason
        let workflowsWithoutReason = _.filter(workflowsToFill, workflow => {
          const indexOfWorkflow = _.findIndex(this.ifttt.action.value, val => {
            return val.workflowId === workflow.key;
          });
          console.log("indexOfWorkflow", {indexOfWorkflow, workflow, iftt: this.ifttt.action.value})
          if (indexOfWorkflow === -1) {
            return true;
          } else {
            return !this.ifttt.action.value[indexOfWorkflow].reason.length;
          }
        });

        console.log("VALID", {workflowsToFill, workflowsWithoutReason})
        if (workflowsWithoutReason.length) {
          return false;
        } else {
          return true;
        }
      } else if (this.ifttt.action.type === 'CUT_DOWNTIME') {
        return true;
      } else {
        return false;
      }
    },
    getReasonTreesToSelect() {
      let workflowsToFill = _.filter(this.ifttt.filters, {'type': 'WORKFLOW'});
      if (!workflowsToFill.length) {
        workflowsToFill = _.map(this.getWorkflows, workflow => {
          return {key: workflow.id, value: workflow.name, type: 'WORKFLOW'}
        });
      }
      return _.map(_.cloneDeep(workflowsToFill), workflow => {
        workflow.trees = _.filter(this.getReasonTrees, tree => {
          return tree.workflows.indexOf(workflow.key) > -1;
        });
        return workflow;
      });
    },
    getWorkflowFilters() {
      let possibleWorkflows = _.filter(this.getWorkflows, wf => {
        let wfId = wf.id;
        let collectionToSearch = this.ifttt.filters;

        return !_.some(collectionToSearch, filter => filter.key === wfId);
      });
      return _.map(possibleWorkflows, workflow => {
        return {key: workflow.id, value: this.$t('workflows.name') + ': ' + workflow.name, type: 'WORKFLOW'}
      })
    },
    getActivityTypeFilters() {
      return _.map(
        _.filter(this.getActivities, activity => {
          return !_.some(this.ifttt.filters, filter => filter.key === activity && filter.type === 'ACTIVITY');
        }),
        activity => {
          return {key: activity, value: this.$t('ifttt.activityType') + ': ' + activity, type: 'ACTIVITY'};
        }
      );
    },
    getPossibleFilters() {
      const workflowFilters = this.getWorkflowFilters;
      const activityTypeFilters = this.getActivityTypeFilters;
      const triggerValueType = _.find(this.possibleTriggers, {type: this.ifttt.trigger.type}).valueType;
      const hasDeclared = _.some(this.ifttt.filters, {key: 'DOWNTIME_DECLARED', type: 'DOWNTIME_DECLARATION_STATUS'});
      const hasUndeclared = _.some(this.ifttt.filters, {key: 'DOWNTIME_UNDECLARED', type: 'DOWNTIME_DECLARATION_STATUS'});
      const customFilters = _.map(_.filter(this.possibleFilters, filter => {
        if (filter.showOnTriggerValueTypes.indexOf(triggerValueType) === -1) return false;
        if (hasDeclared && filter.key === 'DOWNTIME_UNDECLARED') return false;
        if (hasUndeclared && filter.key === 'DOWNTIME_DECLARED') return false;
        return true;
      }), filter => {
        return {key: filter.key, value: filter.value, type: filter.type}
      });
      return _.orderBy(_.concat(workflowFilters, activityTypeFilters, customFilters), ['type'], ['asc'])
    },
    getFormula() {
      const groupedByType = _.groupBy(this.ifttt.filters, 'type');
      const usedTypes = _.keys(groupedByType);

      return '(' + _.map(usedTypes, type => {
        return _.map(groupedByType[type], 'value').join(` ${this.$t('ifttt.or')} `)
      }).join(`) ${this.$t('ifttt.and')} (`) + ')';
    },
    getTriggerFilters() {
      if (!this.ifttt.trigger.type) {
        return []
      }
      const selectedTrigger = _.find(this.possibleTriggers, {'type': this.ifttt.trigger.type});
      return _.filter(this.possibleTriggerFilters, filter => {
        return filter.showOnTriggerValueTypes.indexOf(selectedTrigger.valueType) > -1;
      })

    },
    shouldShowTimeInput() {
      const selectedTrigger = _.find(this.possibleTriggers, {'type': this.ifttt.trigger.type});
      return selectedTrigger ? selectedTrigger.valueType === 'time' : false;
    },
    canGoNext() {
      if (this.currentStep === 0) {
        return this.ifttt.name.length > 0;
      } else if (this.currentStep === 1) {
        if (this.ifttt.trigger.type === null) {
          return false;
        } else {
          const selectedTrigger = _.find(this.possibleTriggers, {'type': this.ifttt.trigger.type});
          console.log("selectedTrigger", selectedTrigger, this.ifttt)
          return selectedTrigger.valueType && this.ifttt.trigger.type;
        }
      } else if (this.currentStep === 2 && !this.ifttt.filters.length) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    changedTags($event) {
      if (!this.originalIfttt || !_.isEqual(this.originalIfttt.filters, this.ifttt.filters)) {
        this.ifttt.action = {type: null, value: null};
        this.ifttt.type = null;
      }
      const hasDeclared = _.some(this.ifttt.filters, {key: 'DOWNTIME_DECLARED', type: 'DOWNTIME_DECLARATION_STATUS'});
      const hasUndeclared = _.some(this.ifttt.filters, {key: 'DOWNTIME_UNDECLARED', type: 'DOWNTIME_DECLARATION_STATUS'});
      if (hasDeclared && hasUndeclared) {
        this.ifttt.filters = _.filter(this.ifttt.filters, f => f.type !== 'DOWNTIME_DECLARATION_STATUS');
      }
    },
    toggleDayFilter(filter) {
      const filterActiveIndex = this.triggerFilterIsActive(filter);
      console.log("INDEX", filter, filterActiveIndex)
      if (filterActiveIndex === -1) {
        this.ifttt.triggerFilters.push({key: filter.key, type: filter.type})
      } else {
        this.ifttt.triggerFilters = _.filter(this.ifttt.triggerFilters, triggerFilter => {
          return triggerFilter.key !== filter.key || triggerFilter.type !== filter.type;
        })
      }
    },
    triggerFilterIsActive(filter) {
      return _.findIndex(this.ifttt.triggerFilters, triggerFilter => {
        return triggerFilter.key === filter.key && triggerFilter.type === filter.type;
      })
    },
    removeFilters() {
      this.ifttt.filters = [];
    },
    setType() {
      this.ifttt.type = _.find(this.actions, {value: this.ifttt.action.type}).type
    },
    getFakeDownTimeOfWorkflowId(workflowId) {
      const found = _.find(this.ifttt.action.value, {workflowId});
      console.log("found", found, _.cloneDeep(found))
      return found ? found : {workflowId, reason: []};
    },
    levelChanged(event, workflowId) {
      console.log("LEVEL CHANGED", event, workflowId)
      if (!event.reasonToSave.length) {
        return;
      }
      const indexToUpdate = _.findIndex(this.ifttt.action.value, value => {
        return value.workflowId === workflowId;
      });
      if (indexToUpdate === -1) {
        if (!this.ifttt.action.value) {
          this.ifttt.action.value = [{workflowId, reason: event.reasonToSave}];
        } else {
          this.ifttt.action.value.push({workflowId, reason: event.reasonToSave});
        }
      } else {
        this.ifttt.action.value.splice(indexToUpdate, 1, {workflowId, reason: event.reasonToSave})
      }
    },
    save() {
      const hasDeclared = _.some(this.ifttt.filters, {key: 'DOWNTIME_DECLARED', type: 'DOWNTIME_DECLARATION_STATUS'});
      const hasUndeclared = _.some(this.ifttt.filters, {key: 'DOWNTIME_UNDECLARED', type: 'DOWNTIME_DECLARATION_STATUS'});
      if (hasDeclared && hasUndeclared) {
        this.$swal({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 5000,
          icon: 'error',
          title: this.$t('ifttt.errorDeclarationStatusConflict')
        });
        return;
      }
      if (this.ifttt.id) {
        this.$store.dispatch('ifttt/patch', {...this.ifttt, companyId: this.getClaims.companyId})
      } else {
        this.$store.dispatch('ifttt/set', {...this.ifttt, companyId: this.getClaims.companyId})
      }
      this.$emit('closeModal', {saved: true})
    }
  },
  created() {
    if (this.originalIfttt) {
      this.ifttt = _.cloneDeep(this.originalIfttt);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/MotivateColors";
@import "../../assets/scss/components/desktop/frameworkVoerroTagInputDesktop";

.footer {
  margin-top: 12px;
}

.progress-button {
  background: none;
  border: none;
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 12px;
  justify-items: center;
  align-items: center;
  color: $ceruleanBlue;
  cursor: pointer;

  &:focus {
    outline: 0 !important;
    color: $royalBlueDark;
  }

  &:disabled {
    color: $cadetGrey;
  }
}

.save-button {
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 12px;
  justify-items: center;
  align-items: center;
}

.ifttt-form, .form-control {
  color: $besWelBlack;
}

.ifttt-progress {
  margin-top: 20px;
  margin-bottom: 20px;
}

.footer {
  margin-top: 40px;
}

.content, .form-control, label {
  font-size: 16px;
}

.extra-info-text {
  margin-top: 20px;
  margin-left: 16px;
  margin-right: 16px;
}

.day-circle[active="-1"] {
  background: $cultured;
}

.day-circle {
  background: $ceruleanBlue;
  border-radius: 24px;
  color: $walterWhite;
  height: 30px;
  font-size: 14px;
  text-align: center;
  display: grid;
  justify-content: center;
  align-content: center;
  width: 30px;
  cursor: pointer;
}

.extra-filters {
  margin-top: 40px;
}

::v-deep  label, .form-control {
  font-size: 14px;
}
</style>
<style>

</style>